module.exports = __webpack_public_path__ + "img/save.b8a9a776.svg";